import classnames from 'classnames';

interface SlideToggleProps<T extends number | string> {
  active: boolean;
  disabled?: boolean;
  handleToggle: (target: T) => void;
  target: T;
}

const SlideToggle = <T extends number | string>({
  active,
  disabled = false,
  handleToggle,
  target,
}: SlideToggleProps<T>) => (
  <div className="slide-item" data-testid={`slide-toggle-${target}`}>
    <input
      checked={active}
      disabled={disabled}
      id={`toggle_${target}`}
      onChange={() => handleToggle(target)}
      type="checkbox"
    />
    <div className="toggle">
      <label className={classnames({ disabled })} htmlFor={`toggle_${target}`}>
        <i />
      </label>
    </div>
  </div>
);

export default SlideToggle;
